import { render, staticRenderFns } from "./strategyDetail.vue?vue&type=template&id=3552daec&scoped=true&"
import script from "./strategyDetail.vue?vue&type=script&lang=js&"
export * from "./strategyDetail.vue?vue&type=script&lang=js&"
import style0 from "./strategyDetail.vue?vue&type=style&index=0&id=3552daec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552daec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3552daec')) {
      api.createRecord('3552daec', component.options)
    } else {
      api.reload('3552daec', component.options)
    }
    module.hot.accept("./strategyDetail.vue?vue&type=template&id=3552daec&scoped=true&", function () {
      api.rerender('3552daec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/strategy/strategyDetail.vue"
export default component.exports